import { Clipboard } from '@angular/cdk/clipboard';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, DOCUMENT, inject, OnInit } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Params, RouterLink } from '@angular/router';
import { Observable } from 'rxjs';

import { getPathWithoutQueryParams, getQueryParamsFromUrl } from '@shared/utils/route.utils';
import { Breadcrumb } from '@features/dashboard/models/dashboard.models';
import { DashboardService } from '@features/dashboard/services/dashboard.service';

import { NgIconComponent } from '@ng-icons/core';

@Component({
  selector: 'srm-breadcrumbs',
  imports: [CommonModule, RouterLink, MatTooltipModule, NgIconComponent],
  templateUrl: './breadcrumbs.component.html',
  styleUrl: './breadcrumbs.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BreadcrumbsComponent implements OnInit {
  private dashboardService = inject(DashboardService);
  private clipboard = inject(Clipboard);
  private document = inject(DOCUMENT);

  public breadcrumbs$!: Observable<Breadcrumb[]>;
  public showCopyLink$!: Observable<boolean>;

  public ngOnInit(): void {
    this.breadcrumbs$ = this.dashboardService.breadcrumbs$;
    this.showCopyLink$ = this.dashboardService.showCopyLink$;
  }

  public copyUrl(): void {
    this.clipboard.copy(this.document.location.href);
  }

  public getRouterLink(url: string): string {
    return getPathWithoutQueryParams(url);
  }

  public getQueryParams(url: string): Params | null {
    return getQueryParamsFromUrl(url);
  }

  public getBreadcrumbTrackKey(index: number, item: Breadcrumb): string {
    return [index, item.url, item.label].join(':');
  }
}
